(function () {
  'use strict';

  angular
    .module('morningFlightPriorToLayoverNight')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('morningFlightPriorToLayoverNight', {
        url: '/morning-flight-prior-to-layover-night',
        views: {
          'morningFlightPriorToLayoverNightView': {
            templateUrl: 'morning-flight-prior-to-layover-night/views/morning-flight-prior-to-layover-night.tpl.html',
            controller: 'morningFlightPriorToLayoverNightCtrl',
            controllerAs: 'morningFlightPriorToLayoverNight'
          }
        }
      });
  }
}());
